// @flow
export const RESOURCE_MODAL_VIEWS = {
  detail: 'detail',
  share: 'share',
  flag: 'flag',
};

export const FLAG_NOTICES = {
  sent: {
    severity: 'success',
    title: "Thanks! We're on it.",
    message: 'Our support team will review this and update the resource.',
  },
  alreadyFlagged: {
    severity: 'info',
    title: 'Already flagged',
    message: 'Someone has already flagged this resource.',
  },
};

// How long the flag notice stays before it fades and collapses away.
export const FLAG_NOTICE_DURATION_MS = 5000;

export const DEFAULT_FILTERS: {
  query?: string,
  collections?: Array<string>,
} = {
  query: '',
  collections: [],
};

export const DEFAULT_DISTANCE = 25;

export const DISTANCE_OPTIONS: Array<number> = [10, 25, 50, 100];

export const CONTACT_METHODS = {
  phone: 'phone',
  email: 'email',
  website: 'website',
  address: 'address',
};
